import { useEffect } from 'react';
import { cleanUnfinishedUploads } from '../store/slices/file';
import { useAppDispatch } from './useAppDispatch';

export function useCleanUnfinishedUploads() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(cleanUnfinishedUploads());
    }, []);
}
